import React, { Component } from "react";
import { Wrapper, MultiLineInput } from "app/NativeComponents/common";

import BracketHelper from "./BracketHelper";

class SectionD extends Component {
  render() {
    if (this.props.template.html_template.section_d.max_length > 0) {
      return (
        <BracketHelper
          name="section_d"
          section_title={this.props.template.html_template.section_d.title}
          onChange={value =>
            this.props.checkForLongWords(value, value => {
              this.props.updateTemplate({ prop: "section_d", value });
            })
          }
          updateTemplate={this.props.updateTemplate}
          prop={"section_d"}
          value={
            this.props.template.section_d == null
              ? this.props.template.html_template.section_d.default_text
              : this.props.template.section_d
          }
          device={this.props.device}
          maxLength={this.props.template.html_template.section_d.max_length}
          {...this.props}
        />
      );
    }

    return <Wrapper />;
  }
}

export default SectionD;
